module.exports = __webpack_public_path__ + "img/dashboard_reduce_sjx.816a6438.svg";